import { render } from "./NeuronMetaDataPanel.vue?vue&type=template&id=d935389c&scoped=true"
import script from "./NeuronMetaDataPanel.vue?vue&type=script&lang=js"
export * from "./NeuronMetaDataPanel.vue?vue&type=script&lang=js"

import "./NeuronMetaDataPanel.vue?vue&type=style&index=0&id=d935389c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d935389c"]])

export default __exports__